module.exports = __webpack_public_path__ + "static/media/Country-Club-Village-1.abafd873.pdf";